export enum WeekTypeEnums {
  PREVIOUS,
  CURRENT,
  NEXT,
}
